import { useAuth } from '../contexts/auth';
import { Navigate, Outlet } from 'react-router-dom';
import { isAdmin } from '../utils';

type Props = {
  checkAdmin?: boolean;
}

export default function RouteGuard({ checkAdmin }: Props) {
  const { token, loggedUser } = useAuth();

  if (!token || (checkAdmin && loggedUser && !isAdmin(loggedUser))) return <Navigate to="/login" />

  return <Outlet />;
}